module.exports = __webpack_public_path__ + "static/media/Me.41558a29.PNG";